/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import BorderCenter from 'galax/react/map/hex/border.center';

import DirectionArrow from './direction.arrow';


export default (props) =>
{
  return <BorderCenter {...props} external Component = {DirectionArrow} />
}
